import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import { mapActions, mapGetters, mapState } from 'vuex'
import { checkReturnInfo } from '../../../../common/utils/return-message-util'
import * as DictionaryConstants from '../../../../constants/DictionaryConstants'
import goOutManagement from './components/go-out-management'
import preInspection from './components/pre-inspection'
import http from '../../../../common/utils/http'
import { API_BASE_URL } from '../../../../common/utils/commonUrl'
import moment from 'moment'
import memberApi from '../../../../api/wx-member/member/member'
import url from '../../../../static/images/code.png'

export default {
  data () {
    return {
      dialogState: false,
      url: url,
      showState: 1000,
      cancelType: '',
      verifySalesAmount: '',
      btnTypeCouponCancel: 'primary',
      btnTypeCouponAndAmountCancel: '',
      centerHeight: document.documentElement.clientHeight - 190 + 'px',
      vehicleBrandsName: '',
      vehicleNameName: '',
      vehicleName: '',
      isShow: false,
      categoryKeyToSubCategoryKeyToCategory: null,
      coupon_1000: '',
      detailsForm: {
        companyName: '',
        address: '',
        reservationPhone: '',
        rescuePhone: '',
        codeToFileIds: {
          logo: []
        } // 图片
      }
    }
  },
  components: {
    goOutManagement: goOutManagement,
    preInspection: preInspection
  },
  computed: {
    ...mapState('wxMemberModule', [
      'qrCode',
      'memberDetail',
      'cancelTypeOptions'
    ]),
    ...mapGetters('wxMemberModule', [
      'memberAvatarUrl',
      'memberVerificationStatus'
    ]),
    avatarUrl () {
      return this.memberAvatarUrl
    },
    memberDetails () {
      if (this.memberDetail && this.memberDetail.memberCarDTOList && this.memberDetail.memberCarDTOList.length) {
        const item = this.memberDetail.memberCarDTOList[0]
        this.vehicleBrandsName = item.vehicleBrandsName
        this.vehicleNameName = item.vehicleNameName
        this.vehicleName = item.vehicleName
      }

      return this.memberDetail
    },
    certificated () {
      return this.memberVerificationStatus
    }
  },
  methods: {
    ...mapActions('wxMemberModule', [
      'getWXSignature',
      'getMemberDetail',
      'cancelCoupon',
      'getUserInfo',
      'getCancelRecord',
      'getCancelTypeOptions'
    ]),
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD') : '-'
    },
    skipToMemberDetail () {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_DETAIL
      })
    },
    skipToMyStoredValue () {
      this.$router.push({
        path: RoutePathConstants.MY_STORED_VALUE_RECORD,
        query: {
          list: JSON.stringify(
            this.memberDetails.storedValueCardInstanceDTOList
          )
        }
      })
    },
    skipToCommonProblem () {
      this.$router.push({
        path: RoutePathConstants.COMMON_PROBLEM
      })
    },
    skipToExclusiveCustomerService () {
      this.$router.push({
        path: RoutePathConstants.EXCLUSIVE_CUSTOMER_SERVICE
      })
    },
    skipToShare () {
      this.$router.push({
        path: RoutePathConstants.SHARE
      })
    },
    skipToDetail () {
      if (!this.memberVerificationStatus) {
        this.skipToMemberDetail()
        return
      }

      this.$router.push({
        path: RoutePathConstants.MY_CAR
      })
    },
    skipToMyOrder () {
      this.$router.push({
        path: RoutePathConstants.MY_ORDER
      })
    },
    skipToMyCoupon () {
      this.$router.push({
        path: RoutePathConstants.MY_COUPON
      })
    },
    skipToConsumptionRecord () {
      this.$router.push({
        path: RoutePathConstants.CONSUMPTION_RECORD
      })
    },
    skipToMyInsuranceRecord () {
      this.$router.push({
        path: RoutePathConstants.MY_EXTENDED_INSURANCE_BRIEF_INTRODUCTION
      })
    },
    skipToRecordsOfConsumption () {
      this.$router.push({
        path: RoutePathConstants.RECORDS_OF_CONSUMPTION
      })
    },
    skipToMyPoints () {
      this.$router.push({
        path: RoutePathConstants.MY_POINTS,
        query: {
          grandTotalPoints: this.memberDetails.grandTotalPoints,
          points: this.memberDetails.points,
          usePoints: this.memberDetails.usePoints
        }
      })
    },
    skipToRankEquity () {
      this.$router.push({
        path: RoutePathConstants.RANK_EQUITY,
        query: {
          levelName: this.memberDetails.levelName,
          grandTotalPoints: this.memberDetails.grandTotalPoints,
          points: this.memberDetails.points
        }
      })
    },
    skipToExchangeRecord () {
      this.$router.push({
        path: RoutePathConstants.EXCHANGE_RECORD
      })
    },
    scanCode () {
      // 获取微信签名
      this.getWXSignature(location.href.split('#')[0])
    },
    async cancellationAfterVerification () {
      if (!this.cancelType) {
        this.$message.warning('核销类型不能为空')
        return false
      }
      if (!this.qrCode) {
        this.$message.warning('核销码不能为空')
        return false
      }
      if (
        this.cancelType ===
        DictionaryConstants.COUPON_AND_SALES_AMOUNT_CANCELLATION &&
        !this.verifySalesAmount
      ) {
        this.$message.warning('现金不能为空')
        return false
      }
      const data = {
        verifySalesType: this.cancelType,
        couponExampleCode: this.qrCode,
        verifySalesAmount: this.verifySalesAmount
      }
      const result = await this.cancelCoupon(data)
      checkReturnInfo(result, '卡券核销')
    },
    async getUserContext () {
      const result = await this.getUserInfo()
      await this.getMemberDetail()
      const applicationConfigResult = await memberApi.getApplicationConfig()
      const appConfigs = applicationConfigResult ? applicationConfigResult.data.value.features : []
      localStorage.setItem('appConfig', JSON.stringify(appConfigs))
      // 判断当前登录人是会员还是员工
      if (result.data.itemType === 1000) {
        this.showState = 1000
      } else if (result.data.itemType === 1) {
        this.showState = 1
        if (result.data.roleCodes.filter(item => item === 'preCheckStaff').length > 0) {
          this.showState = 2000
        }
      }
      // this.showState = 1000
    },
    // 查看核销记录
    skipToCancelRecord () {
      this.$router.push({
        path: RoutePathConstants.CANCEL_RECORD
      })
    },
    skipToMakeAnAppointment () {
      this.$router.push({
        path: RoutePathConstants.CREATE_MAKE_AN_APPOINTMENT
      })
    },
    // 提示开发中
    tipsBuilding () {
      this.$message('功能开发中……')
    },
    couponCancel () {
      this.cancelType = DictionaryConstants.COUPON_CANCELLATION
      this.btnTypeCouponCancel = 'primary'
      this.btnTypeCouponAndAmountCancel = ''
    },
    couponAndAmountCancel () {
      this.cancelType =
        DictionaryConstants.COUPON_AND_SALES_AMOUNT_CANCELLATION
      this.btnTypeCouponCancel = ''
      this.btnTypeCouponAndAmountCancel = 'primary'
    },
    goToShop () {
      this.$router.push({
        path: RoutePathConstants.POINTS_MAIL_HOME_PAGE
      })
    },
    goToMallHomePage () {
      this.$router.push({
        path: RoutePathConstants.NEW_HOUME_PAGE
      })
    },
    goToPageMailService () {
      this.$router.push({
        path: RoutePathConstants.PAGE_MAIL_SERVICE
      })
    },
    goToStoredValueWallet () {
      this.$router.push({
        path: RoutePathConstants.STORED_VALUE_WALLET
      })
    },
    goToCoupon () {
      this.$router.push({
        path: RoutePathConstants.MY_COUPON
      })
    },
    goToMySetUp () {
      this.$router.push({
        path: RoutePathConstants.MYSETUP
      })
    },
    goToMakeAnAppointment (reservationType, status) {
      if (status == 1) {
        this.$router.push({
          path: RoutePathConstants.MAKE_AN_APPOINTMENT,
          query: {
            reservationType: reservationType
          }
        })
      } else {
        this.$message({
          message: '该功能暂未开放！'
        })
      }
    },
    goToOneClickRenewal () {
      this.$router.push({
        path: RoutePathConstants.ONE_CLICK_RENEWAL
      })
    },
    goToOneClickRescue () {
      this.$router.push({
        path: RoutePathConstants.ONE_CLICK_RESCUE
      })
    },
    goToExtendedInsurance () {
      this.$router.push({
        path: RoutePathConstants.EXTENDED_INSURANCE
      })
    },
    isCategoryKeyToSubCategoryKeyToCategoryNotEmpty () {
      return this.categoryKeyToSubCategoryKeyToCategory && Object.keys(this.categoryKeyToSubCategoryKeyToCategory).length
    },
    // 获取车辆提醒信息
    async getMemberSipRemindInfo () {
      if (!this.memberDetails || !this.memberDetails.memberCarDTOList || !this.memberDetails.memberCarDTOList.length) {
        return
      }
      const memberCar = this.memberDetails.memberCarDTOList[0]
      const remindInfos = (await http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getMemberSipRemindInfo?carId=' + memberCar.id)).data.data

      const categoryKeyToSubCategoryKeyToCategory = (remindInfos || []).reduce((acc, curr) => {
        if (!acc[curr.remindBigCategory]) {
          acc[curr.remindBigCategory] = {}
        }

        acc[curr.remindBigCategory][curr.remindSubcategory] = curr
        return acc
      }, {})
      this.categoryKeyToSubCategoryKeyToCategory = categoryKeyToSubCategoryKeyToCategory
    },
    judgeExistence (item, num) {
      if (!item || !num) {
        return false
      }
      return item.hasOwnProperty(num)
    },
    // 获取多少未使用卡券
    getCoupon1000 () {
      http.get(API_BASE_URL + '/api/wxoa/coupon/couponExample/getUserCouponListByMemberId?couponUseStatus=1000').then(
        res => {
          this.coupon_1000 = res.data.data ? res.data.data.length : '0'
        }
      )
    },
    getCompanyInfo () {
      let _this = this
      http.get(API_BASE_URL + '/api/sys/prop/typeId/100/propName/companyInfo').then(
        res => {
          console.log(res)
          // const id = res.data.data.id
          const id = (res.data && res.data.data && res.data.data.id) ? res.data.data.id : '';
          const info = (res.data && res.data.data && res.data.data.value) ? res.data.data.value : {};
          const codeToFileIds = info.codeToFileIds || {}
          codeToFileIds.logo = codeToFileIds.logo || []
          this.id = id
          if (info.companyName === '长春昌融') {
            _this.dialogState = true
          }
          this.detailsForm = {
            companyName: info.companyName,
            address: info.address,
            reservationPhone: info.reservationPhone,
            rescuePhone: info.rescuePhone,
            codeToFileIds: codeToFileIds
          }
          if (codeToFileIds && codeToFileIds.logo) {
            this.assessImageList2 = []
            let fileIds = codeToFileIds.logo
            this.fileIdList = fileIds
          }
        }
      )
    },
    async toGrantAuthorization () {
      const result = await memberApi.getWXSignature({ url: location.href.split('#')[0] })
      console.log(result, 'result')
      console.log(location.href.split('#')[0], 'location')
      let appid = result.appId
      let url = location.href.split('#')[0] + '/wx/bw/linksucai/link/auto'
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`
    }
  },
  async mounted () {
    // 获取会员信息
    await this.getUserContext()

    await this.getMemberSipRemindInfo()

    // 查询字典获取核销方式
    await this.getCancelTypeOptions(
      DictionaryConstants.CANCELLATION_AFTER_VERIFICATION_TYPE
    )
    this.getCoupon1000()

  },
  created () {
    this.getCompanyInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/personal-center.js